import { PageHeader } from "@/ds";
import styles from "./tela-com-abas.module.scss";
import type { TelaComAbasViewProps } from "./types-tela-com-abas";

export function TelaComAbasView({
  titulo,
  abas,
  abasLabel,
  mobileQuery,
  testId,
  headerTestId,
  variante,
  fullBleed,
  ocultarCabecalhoNaImpressao,
  children,
}: TelaComAbasViewProps) {
  return (
    <section
      className={styles.container}
      data-variante={variante}
      data-full-bleed={fullBleed}
      data-testid={testId}
    >
      <PageHeader.Root
        className={styles.header}
        printHide={ocultarCabecalhoNaImpressao}
        testId={headerTestId}
      >
        <PageHeader.Title>{titulo}</PageHeader.Title>
        <PageHeader.Tabs items={abas} aria-label={abasLabel} mobileQuery={mobileQuery} />
      </PageHeader.Root>

      <div className={styles.content}>{children}</div>
    </section>
  );
}
